import { useState, useEffect, useRef } from 'react';
import { NavLink, Link } from 'react-router-dom';
import Header from '~/componentsPage/Header/Header';
import styles from '~/styles/Contact/Contact.module.css';

function Contact() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const themeRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);

  const toggleTheme = () => {
    const isDark = document.body.classList.toggle('dark-mode');
    if (themeRef.current) themeRef.current.textContent = isDark ? '🌙' : '☀️';
  };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (isMenuOpen && menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen]);

  return (
    <div className={styles.pageContainer}>
      <Header />
      <main className={styles.contactContent}>
        <section className={styles.contactHero}>
          <h1>Skontaktuj się z nami</h1>
          <p>Masz pytania dotyczące serwisu? Napisz do nas lub znajdź nas w mediach społecznościowych.</p>
        </section>

        <div className={styles.infoGrid}>
          <div className={styles.contactCard}>
            <div className={styles.cardIcon}>📧</div>
            <h3>Napisz do nas</h3>
            <a href="mailto:kontakt@czateria24.pl" className={styles.emailLink}>
              kontakt@czateria24.pl
            </a>
          </div>

          <div className={styles.contactCard}>
            <div className={styles.cardIcon}>📱</div>
            <h3>Social Media</h3>
            <div className={styles.socialGrid}>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" className={styles.socialBtn}>Instagram</a>
              <a href="https://facebook.com" target="_blank" rel="noreferrer" className={styles.socialBtn}>Facebook</a>
              <a href="https://tiktok.com" target="_blank" rel="noreferrer" className={styles.socialBtn}>TikTok</a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" className={styles.socialBtn}>Twitter</a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" className={styles.socialBtn}>YouTube</a>
            </div>
          </div>
        </div>
      </main>

      {/* FOOTER (Pełna wersja z HomePage) */}
      <footer className={styles.mainFooter}>
        <div className={styles.footerContent}>
          <div className={styles.footerLinks}>
            <Link to="/pomoc">Pomoc</Link>
            <Link to="/kontakt">Kontakt</Link>
            <Link to="/polityka-prywatnosci">Polityka prywatności</Link>
            <Link to="/regulamin">Regulamin</Link>
          </div>

          <div className={styles.disclaimer}>
            <p>
              Serwis <strong>Czateria24</strong> jest przeznaczony wyłącznie dla osób, które ukończyły <strong>18 lat</strong>.
              Korzystanie z portalu oznacza akceptację regulaminu oraz polityki plików cookies.
            </p>
            <p className={styles.legalNotice}>
              Administrator serwisu nie ponosi odpowiedzialności za treści, opinie oraz materiały przesyłane przez użytkowników czatu.
            </p>
          </div>

          <div className={styles.copyright}>
            © Czateria24. Wszystkie prawa zastrzeżone.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Contact;